<template lang='pug'>
  include ./../../mixins
  div
    +b.password-table.TABLE
      +e.row.TR
        +e.header.TH {{_('Daily Password')}}
        +e.header.TH {{_('Date')}}
        +e.header.TH 
      +e.row.TR(v-for='(item, index) in code')
        +e.data.TD(:id='index') {{item}}
        +e.data.TD {{data[index]}}
        +e.data.TD 
          +b.g-row--justify_end
            +b.button--icon_copy.color_blue.appear-from_lg.BUTTON(
              @click='copyToClipboard(index)' 
              v-tooltip.left.notrigger="{ content: tooltipText, visible: ind == index && visibility == true, class: 'tooltip-custom tooltip-other-custom' }"
            ) {{_('Copy to Clipboard')}}

            +b.button--icon_copy.color_blue.none-from_lg.BUTTON(
              @click='copyToClipboard(index)'
              v-tooltip.left.notrigger="{ content: tooltipText, visible: ind == index && visibility == true, class: 'tooltip-custom tooltip-other-custom' }"
            )


</template>

<script>
export default {
  props: {
    code: {
      type: Array
    },
    data: {
      type: Array
    }
  },
  
  data() {
    return {
      visibility: false,
      tooltipText: '',
      ind: null,
    }
  },

  methods: {
    copyToClipboard(ind) {
      let range = document.createRange()
      range.selectNode(document.getElementById(ind))
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
      let isCopied = document.execCommand('copy')
      window.getSelection().removeAllRanges()
      let timeout = 2000
      if (isCopied) {
        this.visibility = true
        this.ind = ind
        this.tooltipText = this._('Copied!')
        setTimeout(() => {
          this.visibility = false
          // this.tooltipText = ''
        }, timeout)
      } else {
        this.visibility = true
        this.tooltipText = this._('Something went wrong')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/PasswordGenerator/ResultTable.vue